// ============================================================
// Application Constants
// ============================================================

export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Smart School ERP';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

export const DEBOUNCE_DELAY = 300;

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY hh:mm A';

export const MOCK_DELAY = {
  SHORT: 300,
  MEDIUM: 600,
  LONG: 1000,
};
